export default __webpack_public_path__ + "static/how_it_works_4-43d3a98919d8b4e80772f13cfdb455ce.png";